import * as classNames from "classNames";
import * as React from "react";
import { Guid } from "../../../react-core/Utils/Guid";
import { ContentTable } from "../../Admin/Company/CompanyWizard/Resource/Content";
import { Contents } from "../../Dashboard/Components/Clients/PortfolioDashboard/Components/Insights/Resource/Contents";
import { Alert } from "../Components/Alert";
import { AlertType } from "../Entities/Constants/AlertConstants";

export interface IColumnChart {
    data: any[];
    height?: number;
    noDataMsg?: string;
    cssWrapper?: string;
    maxBarWidth?: number;
}

export const ColumnChart = (props: IColumnChart) => {
    const { data, height, maxBarWidth } = props;
    if (data.length < 1)
        {return <Alert alertType={AlertType.Warning} message={props.noDataMsg || Contents.noDataErrorMessage} />;}
    const barAreaHeight = height;
    let minValue = data.reduce((a: any, b: any) => (a.Value < b.Value ? a : b)).Value;
    let maxValue = data.reduce((a: any, b: any) => (a.Value > b.Value ? a : b)).Value;
    if (minValue > 0) {minValue = 0;}
    if (maxValue < 0) {maxValue = 0;}
    const minMaxDifference = maxValue - minValue;
    const onePixelValue = barAreaHeight / minMaxDifference;
    const XAxisTop = Math.round(barAreaHeight - -minValue * onePixelValue);
    const dataLength = data.length;

    const zeroLinePosition = Math.round(barAreaHeight - XAxisTop);

    return (
        <div className={classNames("column-chart", props.cssWrapper)}>
            <div className="columns-area" style={{ height: `${barAreaHeight}px` }}>
                <span className="ygrid-item zero" style={{ bottom: `${zeroLinePosition}px` }}>
                    <span className="line"></span>
                </span>
                <div
                    className="bars-row pl-0"
                    style={{ justifyContent: dataLength > 3 ? "space-around" : "flex-start" }}
                >
                    {data.map((barData: any, index: number) => {
                        const barHeight = Math.abs(Math.round(barData.Value * onePixelValue));
                        const barShift = barData.Value < 0 ? XAxisTop : XAxisTop - barHeight;
                        return (
                            <div
                                key={index + Guid.getNext()}
                                className={
                                    "bar " + (barData.Value == 0 ? "zero" : barData.Value < 0 ? "negative" : "positive")
                                }
                                style={{
                                    maxWidth: `${maxBarWidth}px`,
                                }}
                            >
                                <div
                                    className="fill"
                                    style={{
                                        height: `${barHeight}px`,
                                        transform: `translateY(${barShift}px)`,
                                    }}
                                >
                                    <div className={"fill-color chart-bg-" + (index + 1)}></div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <ul
                className="xaxis-labels-row list-style-none pl-0"
                style={{ justifyContent: dataLength > 3 ? "space-around" : "flex-start" }}
            >
                {data.map((barData: any) => {
                    return (
                        <li style={{ width: `${maxBarWidth}px` }} className="label">
                            <div className="text-bold">{barData.Value.toFixed(2)}%</div>
                            <p>{barData.SectorName}</p>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
